export default __webpack_public_path__ + "static/media/refresh-btn-active.c4ae214f.svg";